import { render } from "./LeaveBalanceInsufficientModal.vue?vue&type=template&id=390c149c&scoped=true"
import script from "./LeaveBalanceInsufficientModal.vue?vue&type=script&lang=js"
export * from "./LeaveBalanceInsufficientModal.vue?vue&type=script&lang=js"

import "./leave-balance-modal.scss?vue&type=style&index=0&id=390c149c&lang=scss&scoped=true"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390c149c"]])

export default __exports__